import type { EmbeddedChapter } from '../types';

export const getChapterTitleFromHref = (href: string, linkLabel: string): string => {
  const isLikelyRawUrl = linkLabel.startsWith('/') || linkLabel.startsWith('http');

  if (!isLikelyRawUrl) {
    return linkLabel;
  }

  try {
    const url = new URL(href);
    const pathSegments = url.pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1] || '';
    const slugWithoutId = lastSegment.replace(/^\d+-/, '');
    const decodedSlug = decodeURIComponent(slugWithoutId);
    const titleWithSpaces = decodedSlug.replace(/-/g, ' ');

    return titleWithSpaces.charAt(0).toUpperCase() + titleWithSpaces.slice(1);
  } catch {
    return linkLabel;
  }
};

export const getEmbeddedChapterKey = ({ courseId, chapterId }: EmbeddedChapter) =>
  `${courseId}:${chapterId}`;
